import React from "react";
import T from "prop-types";

import Widget from "2g-widget";

import ProvozniInformaceForm from "b2b/components/provozni-informace-form";

import useProvozniInformaceEditaceWidget from "./useProvozniInformaceEditaceWidget";

function ProvozniInformaceEditaceWidget({ id }) {
  const { title, form } = useProvozniInformaceEditaceWidget(id);

  return (
    <Widget collapsable={false} title={title}>
      <ProvozniInformaceForm {...form} />
    </Widget>
  );
}

ProvozniInformaceEditaceWidget.propTypes = {
  id: T.oneOfType([T.string, T.number])
};

export default React.memo(ProvozniInformaceEditaceWidget);
